export const apiVersionPrefix = "/api/v0";

export const fetchCalendarPath: string = `${apiVersionPrefix}/calendar`;

const experimentsApiPrefix = `${apiVersionPrefix}/experiments`;
export const fetchExperimentsPath = `${experimentsApiPrefix}/active`;

const itineraryApiPrefix = `${apiVersionPrefix}/itinerary`;
export const fetchFlightItineraryPath = `${itineraryApiPrefix}/flight/single`;

export const fetchLocationsPath = `${apiVersionPrefix}/autocomplete/location`;

export const rewardsApiPrefix = `${apiVersionPrefix}/rewards`;
export const fetchRewardsAccountsPath = `${rewardsApiPrefix}/accounts`;
export const travelWalletApiPrefix = `${apiVersionPrefix}/user/wallet`;

export const paymentMethodsApiPrefix: string = `${apiVersionPrefix}/paymentMethods`;

const selfServeApiPrefix = `${apiVersionPrefix}/selfserve`;
// This uses Tysons FareRulesController and Tysons specific logic, which is just for Multi-ticket until that is migrated to b2b-self-serve
export const fetchFlightExchangePolicyPath = `${selfServeApiPrefix}/farerules/exchange`;
// This uses Tysons b2b-interfaces and b2b-self-serve for the implementation
export const fetchFlightExchangeEligibilityQuotePath = `${selfServeApiPrefix}/flight/exchangeEligibilityQuote`;

export const fetchFlightSummariesPathV2 = `${selfServeApiPrefix}/flight/exchangeShop`;
export const exchangeTripDetailsPathV2 = `${selfServeApiPrefix}/flight/tripDetails`;

export const submitFlightExchangePathV2 = `${selfServeApiPrefix}/flight/exchangeAgentFulfill`;

export const scheduleExchangePriceQuotePath = `${selfServeApiPrefix}/flight/exchangeQuoteSchedule`;
export const pollExchangePriceQuotePath = `${selfServeApiPrefix}/flight/exchangeQuotePoll`;
export const scheduleExchangeBookFinalizePath = `${selfServeApiPrefix}/flight/exchangeBookSchedule`;
export const pollExchangeBookFinalizePath = `${selfServeApiPrefix}/flight/exchangeBookPoll`;

const trackingApiPrefix = `${apiVersionPrefix}/tracking`;
export const postAnalyticEventPath = `${trackingApiPrefix}/event`;

export const fetchCityNamePath = `${apiVersionPrefix}/cityName`; //get the name of a city by city code or airport code
